;
define("facets_item_cell_table.tpl", function(){});

